import { Paper } from '@mui/material';
import { type Datum, type SliceTooltipProps } from '@nivo/line';
import { On3IconNilHq } from '@on3/icons';
import { formatCurrency } from '@on3/ui-lib/utils/formatters';
import { TrendArrow } from '@public/components/TrendArrow/TrendArrow';

import styles from './NilChartTooltip.module.scss';

export const percentChange = (valueChange?: number, oldValue?: number) => {
  if (valueChange == null || oldValue == null) {
    return 0;
  }

  return Math.round((valueChange / oldValue) * 100);
};

export type NilChartTooltipProps = Pick<SliceTooltipProps, 'slice'> & {
  allChartData?: Datum[];
};
export const NilChartTooltip = ({
  allChartData,
  slice,
}: NilChartTooltipProps) => {
  const formattedValue = formatCurrency(slice.points?.[0].data.yFormatted);

  const currentIndex = slice.points[0].index;
  const prevIndex = slice.points[0].index - 1;
  const newValue = +(allChartData?.[currentIndex]?.y || 0);
  const oldValue = +(allChartData?.[prevIndex]?.y || 0);
  const valueChange = newValue - oldValue;
  const valuationDelta =
    prevIndex > 0 ? percentChange(valueChange, oldValue) : 0;

  return (
    <Paper className={styles.tooltipContainer}>
      <div className={styles.date}>{slice.points[0].data.xFormatted}</div>
      <On3IconNilHq className={styles.icon} />
      <div className={styles.valuation}>{formattedValue}</div>
      {valuationDelta !== 0 && <TrendArrow percentChange={valuationDelta} />}
    </Paper>
  );
};
